module.exports = __webpack_public_path__ + "img/nivel-prata.04d1ca42.svg";